import React from 'react';

const ReliteLivingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Relite Living</h1>
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600">
            Relite Living offers a fresh perspective on residential design, focusing on creating spaces that inspire and rejuvenate your daily life.
          </p>
          {/* Add more content sections as needed */}
        </div>
      </div>
    </div>
  );
};

export default ReliteLivingPage; 